import { get } from "lodash";
import serverCall from "../../serverCall";

const signUp = (userSignInRequest) => {
  const { email, password } = userSignInRequest;
  return serverCall
    .post(`/auth/login-admin?Email=${email}&Password=${password}`)
    .then((response) => {
      const data = get(response, "data", null);
      if (data) {
        const user = data.user;
        const token = data.accessToken;
        localStorage.setItem("token", token);
        const userAndToken = {
          user,
          token,
        };
        localStorage.setItem("userProfile", JSON.stringify(userAndToken));
      }
      return data;
    });
};

const AuthenticationService = {
  signUp,
};

export default AuthenticationService;
